export const merchGarmentConfigs = {
  "ascolour-5082": {
    id: "ascolour-5082",
    name: "AS Colour 5082 Oversized Faded T-Shirt",
    aspectRatio: "8 / 9",
    supportedColors: ["Faded Black", "Faded Coal", "Faded Bone"],
    measurements: {
      measurementReferenceSize: "XL",
      garmentWidthInches: 24.8,
      garmentLengthInches: 31.89,
      frontPrintWidthInches: 4,
      backPrintWidthInches: 11
    },
    imageKeys: { front: "front", back: "back" },
    printAreas: {
      front: { left: 30, top: 13, width: 40, height: 47.4 },
      back: {
  left: 29.5,
  top: 15.2,
  width: 39.8,
  height: 46.9,
}
    },
    artworkLayerWidths: {
      front: 76,
      back: 90
    },
    artworkContentWidthRatios: {
      front: 0.3,
      back: 0.73
    },
    defaultArtworkCalibration: {
      front: { xOffset: 0, yOffset: 0, scaleMultiplier: 1 },
      back: {
  xOffset: 0,
  yOffset: 0,
  scaleMultiplier: 1,
}
    },
    fallbackSilhouette: {
      viewBox: "0 0 800 900",
      bodyPath: "M250 76 L326 42 Q400 82 474 42 L550 76 L744 178 L658 342 L580 300 L602 850 L198 850 L220 300 L142 342 L56 178 Z",
      collarPath: "M326 42 Q400 118 474 42 Q455 136 400 144 Q345 136 326 42"
    }
  }
};

export function getMerchGarmentConfig(garmentId) {
  return merchGarmentConfigs[garmentId] || null;
}

export function getConfiguredGarmentView(garmentConfig, view, override) {
  return {
    printArea: {
      ...garmentConfig.printAreas[view],
      ...(override?.printArea || {})
    },
    calibration: {
      ...garmentConfig.defaultArtworkCalibration[view],
      ...(override?.calibration || {})
    }
  };
}
